import { UserAvatar } from "@/components/ui/stacked-avatars";
import { cn } from "@/lib/utils";
import { Scribbles } from "@somethings-ui/core/assets";

interface DeepThoughtsSummaryCardProps {
  teenName?: string;
  teenAvatarUrl: string | null;
  onClick?: () => void;
}

export function DeepThoughtsSummaryCard({
  teenName,
  teenAvatarUrl,
  onClick,
}: DeepThoughtsSummaryCardProps) {
  const interactive = !!onClick;

  const content = (
    <div
      className={cn(
        "relative mx-auto w-full max-w-[361px] overflow-hidden rounded-2xl bg-brand-darkMaroon p-4 shadow-[0_0_16px_rgba(0,0,0,0.08)]",
        interactive && "cursor-pointer text-left",
      )}
    >
      <img
        src={Scribbles.orangeCloud}
        alt=""
        aria-hidden
        className="pointer-events-none absolute inset-0 h-full w-full scale-[1.6] object-cover"
      />

      <div className="relative flex flex-col gap-4">
        <UserAvatar
          imageUrl={teenAvatarUrl ?? undefined}
          name={teenName ?? ""}
          size={32}
          showBorder
        />

        <div className="flex items-center justify-between gap-2">
          <p className="font-avantt text-xl font-bold leading-[1.15] tracking-[-0.2px] text-white">
            Deep Thoughts
          </p>
          <span className="font-mono text-xs font-medium tracking-[-0.24px] text-white">
            View answers
          </span>
        </div>
      </div>
    </div>
  );

  if (interactive) {
    return (
      <button type="button" onClick={onClick} className="w-full">
        {content}
      </button>
    );
  }

  return content;
}
